<button class="small-icon-button" mat-icon-button [cdkCopyToClipboard]="'' + value" [matTooltip]="'Copy to clipboard'">
  <y42-icon icon="copy"></y42-icon>
</button>
